// W8ED product territories. Nothing here is purchasable unless its status says LIVE.
export const PRODUCTS = [
  {
    id: "functional-foods",
    name: "FUNCTIONAL FOODS",
    status: "IN DEVELOPMENT",
    line: "Everyday food designed to carry more nutritional weight.",
  },
  {
    id: "protein",
    name: "PROTEIN",
    status: "IN DEVELOPMENT",
    line: "The most under-consumed structural nutrient, made easier to repeat.",
  },
  {
    id: "fibre",
    name: "FIBRE",
    status: "CONCEPT",
    line: "The quiet signal behind metabolic and gut health.",
  },
  {
    id: "functional-beverages",
    name: "FUNCTIONAL BEVERAGES",
    status: "CONCEPT",
    line: "What people drink every day is a repeated signal too.",
  },
  {
    id: "daily-health",
    name: "DAILY HEALTH",
    status: "CONCEPT",
    line: "The baseline layer — small inputs, repeated daily.",
  },
  {
    id: "performance-nutrition",
    name: "PERFORMANCE NUTRITION",
    status: "CONCEPT",
    line: "Fuel and recovery for people building capacity.",
  },
  {
    id: "healthy-ageing",
    name: "HEALTHY AGEING",
    status: "CONCEPT",
    line: "Nutrition for the decades where muscle, metabolism and recovery decide independence.",
  },
  {
    id: "womens-health",
    name: "WOMEN'S HEALTH",
    status: "CONCEPT",
    line: "Designed for physiology, not resized from someone else's.",
  },
  {
    id: "kids-nutrition",
    name: "KIDS NUTRITION",
    status: "CONCEPT",
    line: "The earliest repeated signals matter the longest.",
  },
];

export const productById = (id) => PRODUCTS.find((p) => p.id === id);
